import { ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireExpenses: QuestionnaireFlowType = {
    id: FindingAreasEnum.Expenses,
    name: getFindingAreaDisplayText(FindingAreasEnum.Expenses),
    questions: [
        {
            id: `${FindingAreasEnum.Expenses}:Q1`,
            text: "Do you have a written expenses policy in place?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Expenses}:Q2A`,
                no: `${FindingAreasEnum.Expenses}:Q2B`,
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q2A`,
            text: "Are claims subject to a review/sign off process?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Expenses}:Q3A`,
                no: `${FindingAreasEnum.Expenses}:Q3B`,
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q2B`,
            text: "Do employees/directors make expense claims?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red, 
                no: ConclusionKeys.Green
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q3A`,
            text: "Has the policy been reviewed from a tax perspective?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Expenses}:Q4A`,
                no: `${FindingAreasEnum.Expenses}:Q4B`,
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q3B`,
            text: "Has the policy been reviewed from a tax perspective?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
               yes: ConclusionKeys.Red,
                no: ConclusionKeys.Red
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q4A`,
            text: "Are receipts required to be provided/uploaded as part of the expenses policy?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Expenses}:Q5A`,
                no: `${FindingAreasEnum.Expenses}:Q5B`,
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q4B`,
            text: "Are receipts required to be provided/uploaded as part of the expenses policy?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Expenses}:Q5C`,
                no: `${FindingAreasEnum.Expenses}:Q5D`,
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q5A`,
            text: "Are employees allowed to expense any personal expenditure or 'home to work' travel?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Green
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q5B`,
            text: "Are employees allowed to expense any personal expenditure or 'home to work' travel?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
               yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q5C`,
            text: "Are employees allowed to expense any personal expenditure or 'home to work' travel?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            },
        },
        {
            id: `${FindingAreasEnum.Expenses}:Q5D`,
            text: "Are employees allowed to expense any personal expenditure or 'home to work' travel?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Amber
            },
        }
    ],
};

export default questionnaireExpenses;
